module.exports = __webpack_public_path__ + "static/media/empty-search.4f53be70.svg";